const styles = {
  chip: {
    position: 'absolute',
    top: 10,
    left: 10,
  },
  img: {
    width: '100%',
    height: '100%',
    borderRadius: 2,
    boxShadow: 3,
    objectFit: 'contain',
  },
  card: {
    flex: 1,
  },
  hideIcon: {
    color: 'transparent',
  },
};

export default styles;
